/** Edge function URL an AI assistant connects to (Model Context Protocol). */
export const getMcpUrl = (
  supabaseUrl: string | undefined = import.meta.env.VITE_SUPABASE_URL,
): string => `${supabaseUrl}/functions/v1/mcp`;

/**
 * Short, masked form of the MCP URL for display: the project subdomain is
 * cut ("abcd….supabase.co/…/mcp") so the full address only leaves the app
 * through the copy button.
 */
export const maskMcpUrl = (url: string): string => {
  try {
    const { hostname } = new URL(url);
    const [subdomain, ...domain] = hostname.split(".");
    const host =
      domain.length >= 2 && subdomain.length > 4
        ? `${subdomain.slice(0, 4)}….${domain.join(".")}`
        : hostname;
    return `${host}/…/mcp`;
  } catch {
    return "…/mcp";
  }
};
